module.exports = __webpack_public_path__ + "img/ic_commonly_grey.4553cf07.svg";